<script>
	import { onMount } from 'svelte';
	import { useStoryblokBridge, StoryblokComponent } from '@storyblok/svelte';
	import StructuredData from '$lib/../components/seo/StructuredData.svelte';
	import { useStoryblok } from '$lib/storyblok.js';
	import { page } from '$app/stores';
	import { PUBLIC_WEBSITE_URL } from '$env/static/public';

	export let data;

	onMount(async () => {
		await useStoryblok();
		if (data.story) {
			useStoryblokBridge(data.story.id, (newStory) => (data.story = newStory), {
				preventClicks: true
			});
		}
	});
</script>

<svelte:head>
	{#key data}
		{#if data.story.content.component == 'HomepageSinterklaas' || data.story.content.component == 'NieuwsPagina' || data.story.content.component == 'ShopOverzichtPagina' || data.story.content.component == 'VacaturePagina' || data.story.content.component == 'VacatureOverzichtPagina' || data.story.content.component == 'Bedankpagina'}
			<title
				>{data.globaleInstellingen.content.website_naam +
					' | ' +
					(data.story.content.og_title
						? data.story.content.og_title
						: data.story.content.titel)}</title
			>
			<meta
				property="og:title"
				content={data.globaleInstellingen.content.website_naam + ' | ' + data.story.content.og_title
					? data.story.content.og_title
					: data.story.content.titel}
			/>
		{:else}
			<title
				>{data.globaleInstellingen.content.website_naam +
					' | ' +
					(data.story.content.og_title ? data.story.content.og_title : data.story.name)}</title
			>
			<meta
				property="og:title"
				content={data.globaleInstellingen.content.website_naam + ' | ' + data.story.content.og_title
					? data.story.content.og_title
					: data.story.content.name}
			/>
		{/if}
		<link rel="canonical" href="{PUBLIC_WEBSITE_URL}{$page.url.pathname}" />
		<meta name="robots" content={data.story.content.robots} />
		<meta
			name="description"
			content={data.story.content.og_description
				? data.story.content.og_description
				: data.globaleInstellingen.content.og_description}
		/>
		<meta
			property="og:description"
			content={data.story.content.og_description
				? data.story.content.og_description
				: data.globaleInstellingen.content.og_description}
		/>
		<meta property="og:locale" content="nl_NL" />
		<meta property="og:type" content="website" />
		<meta property="og:site_name" content={data.globaleInstellingen.content.website_naam} />
		<meta property="og:url" content={data.href} />
		<meta
			property="og:image"
			content={data.story.content.og_image.filename
				? data.story.content.og_image.filename
				: data.globaleInstellingen.content.og_image.filename}
		/>
		<meta
			name="image"
			content={data.story.content.og_image.filename
				? data.story.content.og_image.filename
				: data.globaleInstellingen.content.og_image.filename}
		/>

		{#if data.globaleInstellingen.content.meta_tags}
			{@html data.globaleInstellingen.content.meta_tags}
		{/if}
	{/key}
</svelte:head>
{#if data.story}
	{#key data.story}
		<StructuredData algemeen={data.globaleInstellingen.content} story={data.story} />
		<StoryblokComponent blok={data.story.content} published_at={data.story.published_at} />
	{/key}
{/if}
